import React, { useState, useEffect, useRef } from "react";
import SelectAllCheckboxComponent from './selectAllCheckbox.component';

function SelectAllCheckboxContainer({
  actionItems,
  popperStyle,
  disabled,
  isSelectAll,
  selectedIdLength,
  totalFiltered,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef(null)

  const handleToggleOpen = () => {
    setIsOpen((prev) => !prev)
  };

  const handleClose = (event) => {
    if(anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setIsOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(isOpen);
  useEffect(() => {
    if (prevOpen.current === true && isOpen === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = isOpen;
  }, [isOpen]);

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setIsOpen(false);
    }
  }

  return (
    <SelectAllCheckboxComponent
      isOpen={isOpen}
      handleToggleOpen={handleToggleOpen}
      anchorRef={anchorRef}
      handleListKeyDown={handleListKeyDown}
      handleClose={handleClose}
      actionItems={actionItems}
      popperStyle={popperStyle}
      disabled={disabled === null||disabled === undefined ? false:disabled}
      isSelectAll={isSelectAll}
      selectedIdLength={selectedIdLength}
      totalFiltered={totalFiltered}
    />
  );
}

export default SelectAllCheckboxContainer